<!-- eslint-disable i18next/no-literal-string -->
<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div class="mc-sidebar-liveview__fleet">
    <div v-if="$store.state.video.loadingFleets" class="mc-sidebar--loading">
      <b-spinner label="Loading..." />
    </div>

    <b-list-group
      v-if="!$store.state.video.loadingFleets"
      class="mc-sidebar-liveview__list-fleet mc-sidebar-trackvideo__list-fleet"
    >
      <template v-if="renderList">
        <!-- eslint-disable vue/no-use-v-if-with-v-for -->
        <b-list-group-item
          v-for="(row, index) in dataByStatus"
          v-if="row.showInList"
          :id="`vehicle-${row.vehicleId}`"
          :key="row.vehicleId"
          :class="[
            {
              selected: row.selected,
            },
            'mc-sidebar-liveview_list_fleet_container',
          ]"
        >
          <div
            class="mc-sidebar-liveview_list_fleet_checkbox mc-sidebar-trackvision_list_fleet_checkbox"
          >
            <b-form-checkbox
              :id="`checkbox-${row.vehicleId}`"
              v-model="dataByStatus[index].checked"
              :class="{
                'mc-sidebar-liveview-checkbox--disabled': !row.statusText,
              }"
              :disabled="!row.statusText"
              @change="checkedPickVehicle(row, index)"
            />
          </div>

          <div class="mc-sidebar-liveview_list-fleet-detail-wrapper">
            <div class="clearfix mc-sidebar-liveview_list-fleet-top-wrapper">
              <span
                v-b-tooltip.hover
                class="mc-trackvision-sidebar__license-plate"
                :class="{
                  'pull-left': true,
                  'mc-sidebar-liveview-button--disabled': false,
                }"
                title=""
                @click="pickVehicle(row, index)"
              >
                {{ row.vehicle.licensePlate }}
              </span>
              <div class="mc-sidebar-liveview_list-fleet-top-badge-wrapper">
                <template>
                  <b-button
                    v-if="!$store.state.video.voipVehicleIdActives.includes(row.vehicleId)"
                    v-b-tooltip.hover
                    class="mc-sidebar-liveview_button-video-play"
                    :class="{
                      disabled:
                        $store.state.video.voipVehicleIdActives.length > 0 &&
                        !$store.state.video.voipVehicleIdActives.includes(row.vehicleId),
                    }"
                    :title="$t('trackVideo.vehicleCommunication')"
                    @click="handleClickStartCall(row)"
                  >
                    <i class="mc-fa icon-outline_phone"></i>
                  </b-button>
                  <!-- Button for stop call -->
                  <b-button
                    v-else
                    v-b-tooltip.hover
                    class="mc-sidebar-liveview_button-video-play active"
                    :title="$t('trackVideo.vehicleCommunication')"
                    @click="handleClickEndCall(row)"
                  >
                    <i class="mc-fa icon-outline_phone-off"></i>
                  </b-button>
                </template>
              </div>
            </div>

            <div v-if="showHideDetail" class="mc-sidebar-liveview__list-fleet-showhide">
              <div
                v-if="$store.state.video.fleetListDisplay.label_hull && row.vehicle.hullNo"
                class="mc-sidebar-liveview__list-fleet-showhide-wrapper"
              >
                <span>
                  <i class="mc-fa icon-outline_license-general"></i>
                  {{ row.vehicle.hullNo }}
                </span>
              </div>
              <b-row>
                <b-col sm="4">
                  <span>
                    {{ $t('trackVideo.imei') }}
                  </span>
                </b-col>
                <b-col sm="1">
                  <span>:</span>
                </b-col>
                <b-col sm="7">
                  <span>
                    <strong>
                      <div
                        v-if="row.vehicle.imei"
                        class="mc-sidebar-liveview__list-fleet-showhide-wrapper"
                      >
                        <span> {{ row.vehicle.imei }} </span>
                      </div>
                      <div v-else class="mc-sidebar-liveview__list-fleet-showhide-wrapper">
                        <span>-</span>
                      </div>
                    </strong>
                  </span>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <span>
                    {{ $t('trackVideo.device') }}
                  </span>
                </b-col>
                <b-col sm="1">
                  <span>:</span>
                </b-col>
                <b-col sm="7">
                  <span>
                    <strong>
                      <div
                        v-if="row.vehicle.device.deviceName"
                        class="mc-sidebar-liveview__list-fleet-showhide-wrapper"
                      >
                        <span> {{ row.vehicle.device.deviceName }} </span>
                      </div>
                      <div v-else class="mc-sidebar-liveview__list-fleet-showhide-wrapper">
                        <span>-</span>
                      </div>
                    </strong>
                  </span>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <span>
                    {{ $t('trackVideo.simCard') }}
                  </span>
                </b-col>
                <b-col sm="1">
                  <span>:</span>
                </b-col>
                <b-col sm="7">
                  <span>
                    <strong>
                      <div
                        v-if="row.vehicle.device.phoneNo"
                        class="mc-sidebar-liveview__list-fleet-showhide-wrapper"
                      >
                        <span> {{ row.vehicle.device.phoneNo }} </span>
                      </div>
                      <div v-else class="mc-sidebar-liveview__list-fleet-showhide-wrapper">
                        <span>-</span>
                      </div>
                    </strong>
                  </span>
                </b-col>
              </b-row>
              <div class="mc-sidebar-liveview__list-fleet-showhide-wrapper">
                <span v-if="$store.state.video.fleetListDisplay.label_classification">
                  <i class="mc-fa icon-outline_bus"></i>
                  <template
                    v-if="$store.state.video.fleetListDisplay.classification_type == 'category'"
                  >
                    {{
                      row.vehicle.vehicleType
                        ? row.vehicle.vehicleType.category
                        : $t('global.text.noCategory')
                    }}
                  </template>
                  <template
                    v-else-if="$store.state.video.fleetListDisplay.classification_type == 'type'"
                  >
                    {{ row.vehicle.vehicleType.type }}
                  </template>
                  <template v-else>{{ row.vehicle.vehicleType.manufacturer }}</template>
                </span>
                <span v-if="$store.state.video.fleetListDisplay.label_driver">
                  <i class="mc-fa icon-outline_person"></i>
                  {{
                    row.vehicle.driver1 ? row.vehicle.driver1.fullname : $t('global.text.noDriver')
                  }}
                </span>
              </div>

              <b-card v-if="row.statusText" border-variant="light" no-body class="border">
                <div class="d-flex flex-row">
                  <!--  eslint-disable-next-line vue/singleline-html-element-content-newline -->
                  <div class="p-2">{{ $t('trackVideo.camera') }} :</div>
                  <div class="pt-2 mc-channel-wrapper">
                    <b-form-checkbox-group
                      v-model="row.playlist"
                      class="clearfix"
                      :options="row.channel"
                      plain
                      @change="(e) => checkPlaylist(row, index, e)"
                    />
                  </div>
                </div>
              </b-card>
            </div>
          </div>
        </b-list-group-item>
      </template>
    </b-list-group>
  </div>
</template>

<script>
import { Helper } from '@/mixin/helper'
import { mapActions, mapGetters } from 'vuex'
import responsive from '@/mixin/responsive'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'ListFleet',
  mixins: [Helper, responsive],
  data() {
    return {
      device: null,
      playlist: [],
      search: {
        licensePlate: null,
      },
      orderBy: {
        objName: 'licensePlate',
        order: 'asc',
        type: 'string',
      },
      orderActive: 2,
      fleetFilterStatus: {
        all: true,
        running: false,
        idle: false,
        parking: false,
        offline: false,
      },
      status: {
        moving: 0,
        idle: 0,
        offline: 0,
        parking: 0,
      },
      dataByStatus: [],
      sortPopover: false,
      showHideDetail: true,
      renderList: false,
      jwtEncryptWsGps: null,
    }
  },
  computed: {
    ...mapGetters('video', [
      'fleetsListFilter',
      'fleetsList',
      // 'tempVehicleStatusByVehicleId',
      // 'vehicleStatusByVehicleId',
    ]),
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      hasAccess: 'identity/hasAccess',
    }),
  },
  async created() {
    this.search.licensePlate = JSON.parse(localStorage.getItem('device')).vehicle.license_plate
    this.device = JSON.parse(localStorage.getItem('device'))
    await this.loadData()
  },
  mounted() {
    this.$root.$on('refreshFleets', function () {
      this.refreshFleets()
    })
  },
  methods: {
    ...mapActions('video', ['getTotalCamera', 'setVideoStreamStatus']),

    async loadData() {
      this.$store.commit('video/loadingFleets', true)
      this.dataByStatus = []
      this.renderList = false

      await this.getTotalCamera({})

      this.dataByStatus = this.fleetsListFilter(this.search.licensePlate).map((data) => ({
        ...data,
        showInList: true,
      }))

      this.renderList = true
      this.$store.commit('video/loadingFleets', false)
    },

    refreshFleets() {
      this.dataByStatus = this.fleetsListFilter(this.search.licensePlate)
    },

    checkDetailVehicleList() {
      this.showHideDetail = !this.showHideDetail
    },

    filterDataStatusBySearch() {
      let result
      if (!this.search.licensePlate) {
        result = this.dataByStatus.map((data) => ({
          ...data,
          showInList: true,
        }))
      } else {
        result = this.dataByStatus.map((data) => {
          const isMatchLicensePlate = data.vehicle.licensePlate
            ?.toLowerCase()
            .match(this.search.licensePlate?.toLowerCase())
          const isMatchDriverFullname = data.vehicle?.driver1?.fullname
            .toLowerCase()
            .match(this.search.licensePlate?.toLowerCase())
          if (isMatchLicensePlate || isMatchDriverFullname) {
            return {
              ...data,
              showInList: true,
            }
          }
          return {
            ...data,
            showInList: false,
          }
        })
      }
      return result
    },

    async searchVehicle() {
      this.dataByStatus = this.filterDataStatusBySearch()
      this.$forceUpdate()
    },

    pickVehicle(data, index) {
      this.renderList = false
      this.dataByStatus[index].selected = !this.dataByStatus[index].selected
      this.renderList = true
    },

    async checkedPickVehicle(data) {
      const oldData = { ...data }
      data.oldPlaylist = oldData.tempPlaylist ?? []

      if (data.checked === false) {
        data.playlist = []
        data.tempPlaylist = []
      } else {
        data.playlist = data.channel.map((x) => x.value)
        data.tempPlaylist = data.channel.map((x) => x.value)
      }
      await this.$nextTick()

      data.oldPlaylistWithUid = oldData?.playlistWithUid ?? []
      await this.$nextTick()
      data.playlistWithUid = data.playlist.map((playlist) => {
        const isOldPlaylist = data.oldPlaylistWithUid.some((data) => data.playlist === playlist)
        if (isOldPlaylist) {
          return {
            playlist,
            uid: data.oldPlaylistWithUid.find((data) => data.playlist === playlist).uid,
          }
        }
        return { playlist, uid: uuidv4() }
      })

      const { channelSent, channelNotSent } = await this.setVideoStreamStatus(data)

      const isAllChannelNotSent =
        data.channel.length === data.playlist.length &&
        channelNotSent.length === data.channel.length &&
        channelSent.length === 0

      const deviceType = this.getDeviceType(data.vehicle.device.deviceCode)

      const isJc = deviceType === 'jc'
      if (data.checked && isAllChannelNotSent) {
        data.checked = false

        await this.$nextTick()

        data.playlist = []
        data.tempPlaylist = []
        data.playlistWithUid = []
        data.oldPlaylist = oldData.oldPlaylist ?? []
        data.oldPlaylistWithUid = oldData.oldPlaylistWithUid ?? []
        this.$mcToast.error(this.$t('videoHistory.video.playbackOrStreamingGoinOn'))
      }
      if (
        data.checked &&
        channelNotSent.length &&
        channelNotSent.length < data.channel.length
      ) {
        const _playlist = channelSent.map(
          (channel) => `${data.vehicleId}:${isJc ? parseInt(channel) - 1 : channel}`
        )
        data.playlist = _playlist
        data.tempPlaylist = _playlist
        await this.$nextTick()
        data.playlistWithUid = data.playlistWithUid.filter((playlistUid) =>
          data.playlist.includes(playlistUid.playlist)
        )
        data.oldPlaylist = oldData.oldPlaylist ?? []
        data.oldPlaylistWithUid = oldData.oldPlaylistWithUid ?? []
        this.$mcToast.error(this.$t('videoHistory.video.playbackOrStreamingGoinOn'))
      }
      this.$forceUpdate()
      this.$store.commit('video/setPlaylist', data)
    },

    async checkPlaylist(data, index, values) {
      const oldData = { ...this.dataByStatus[index] }
      this.dataByStatus[index].oldPlaylist = oldData.tempPlaylist ?? []
      this.dataByStatus[index].playlist = values
      this.dataByStatus[index].tempPlaylist = values

      if (this.dataByStatus[index].playlist.length === 0) this.dataByStatus[index].checked = false
      else this.dataByStatus[index].checked = true
      await this.$nextTick()

      // Get prev uncheck
      if (this.dataByStatus[index].playlist.length < this.dataByStatus[index].oldPlaylist.length) {
        this.dataByStatus[index].oldPlaylist.find(
          (playlist) => !this.dataByStatus[index].playlist.includes(playlist)
        )
      }

      this.dataByStatus[index].oldPlaylistWithUid = oldData?.playlistWithUid ?? []
      await this.$nextTick()

      this.dataByStatus[index].playlistWithUid = this.dataByStatus[index].playlist.map(
        (playlist) => {
          const isOldPlaylist = this.dataByStatus[index].oldPlaylistWithUid.some(
            (data) => data.playlist === playlist
          )
          if (isOldPlaylist) {
            return {
              playlist,
              uid: this.dataByStatus[index].oldPlaylistWithUid.find(
                (data) => data.playlist === playlist
              ).uid,
            }
          }
          return { playlist, uid: uuidv4() }
        }
      )
            
      const { channelSent, channelNotSent } = await this.setVideoStreamStatus(
        this.dataByStatus[index]
      )

      const deviceType = this.getDeviceType(this.dataByStatus[index].vehicle.device.deviceCode)

      if (values.length) {
        const isJc = deviceType === 'jc'
        const prevChannelActive = this.dataByStatus[index].oldPlaylist.map((playlist) =>
          isJc ? (parseInt(playlist.split(':')[1]) + 1).toString() : playlist.split(':')[1]
        )

        const channelCanPlay = [
          ...channelSent,
          ...prevChannelActive.filter((data) => channelNotSent.includes(data)),
        ]

        const _playlistCanPlay = channelCanPlay.map(
          (channel) =>
            `${this.dataByStatus[index].vehicleId}:${isJc ? parseInt(channel) - 1 : channel}`
        )
        this.dataByStatus[index].playlist = _playlistCanPlay
        this.dataByStatus[index].tempPlaylist = _playlistCanPlay
        await this.$nextTick()
        if (_playlistCanPlay.length < values.length) {
          this.dataByStatus[index].playlistWithUid = this.dataByStatus[
            index
          ].playlistWithUid.filter((playlistUid) =>
            this.dataByStatus[index].playlist.includes(playlistUid.playlist)
          )
          this.dataByStatus[index].oldPlaylist = oldData.oldPlaylist ?? []
          this.dataByStatus[index].oldPlaylistWithUid = oldData.oldPlaylistWithUid ?? []
          this.$mcToast.error(this.$t('videoHistory.video.playbackOrStreamingGoinOn'))
        }
        if (!_playlistCanPlay.length) {
          this.dataByStatus[index].checked = false
        }
      }

      this.$forceUpdate()

      this.$store.commit('video/setPlaylist', this.dataByStatus[index])
    },

    async handleClickStartCall(data) {
      this.$store.commit('voip/setIsShowWidget', true)
      const deviceType = this.getDeviceType(this.device?.deviceCode)

      this.$store.commit('voip/addCalls', {
        vehicleId: data.vehicleId,
        licensePlate: data.vehicle.licensePlate,
        driver: data.vehicle.driver1?.fullname ?? null,
        imei: data.vehicle.imei,
        deviceType,
        isDebugBroadcast: false,
      })
      this.$store.commit('video/addVoipVehicleIdActive', data.vehicleId)
    },

    async handleClickEndCall(data) {
      this.$store.commit('voip/removeCalls', data.vehicleId)
      this.$store.commit('video/removeVoipVehicleIdActive', data.vehicleId)
      this.$store.commit('video/deleteVoipState', data.vehicleId)
    },
  },
}
</script>
